import { render, staticRenderFns } from "./Cashier.vue?vue&type=template&id=dd6271f6&scoped=true&"
import script from "./Cashier.vue?vue&type=script&lang=js&"
export * from "./Cashier.vue?vue&type=script&lang=js&"
import style0 from "./Cashier.vue?vue&type=style&index=0&id=dd6271f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6271f6",
  null
  
)

export default component.exports